import { CoreAttr, CoreClz, GovernanceAttr, GovernanceClz } from '@infa-hawk/models';

import { ServiceRegistry } from '../../context/ServiceRegistryContext';
import { IElasticSearchResp } from '../ccgf-searchv2/ElasticService.types';
import { SearchXINFASEARCHLANGUAGE } from '../ccgf-searchv2/generated/apis/HybridSearchApi';
import * as runtime from '../runtime';
import { IInitializeServiceOptions } from '../types';
import { DocumentType, IFrsDocument } from './models';

export type IGetFrsServiceRequest = {
	ids: string[];
	filter: {
		documentType?: DocumentType[];
		name?: string;
		description?: string;
		tags?: string;
	};
	search?: string;
	expand?: string[];
	count?: boolean;
	from?: number;
	size?: number;
	orderby?: string;
};
export type IGetFrsServiceResponse = {
	'@odata.context'?: string;
	'@odata.count'?: number;
	'value': IFrsDocument[];
};
export interface IGetFrsNativeDataResponse extends IFrsDocument {
	'@odata.context'?: string;
}
export class FrsService extends runtime.BaseAPI {
	constructor(
		configuration: runtime.Configuration | undefined,
		private tenantId: string,
	) {
		super(configuration);
	}

	//TODO
	//1. tags
	//2. createdOn and updatedOn
	async getRuleNativeDataRaw(
		requestParameters: { id: string },
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetFrsNativeDataResponse>> {
		if (requestParameters.id === null || requestParameters.id === undefined || !requestParameters.id.length) {
			throw new runtime.RequiredError('ids', 'Required parameter requestParameters.assetId was null or undefined or empty when calling getRulesByids.');
		}
		const { id } = requestParameters;
		const response = await this.request(
			{
				path: `/api/v1/Documents('${id}')?$expand=nativeData`,
				method: 'GET',
				headers: {
					'X-INFA-ORG-ID': this.tenantId,
				},
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}
	async getRuleNativeData(requestParameters: { id: string }, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IGetFrsNativeDataResponse> {
		const response = await this.getRuleNativeDataRaw(requestParameters, initOverrides);
		return response.value();
	}
	async getRuleInfoByIdsRaw(
		requestParameters: Omit<IGetFrsServiceRequest, 'filter' | 'from' | 'size'>,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetFrsServiceResponse>> {
		if (requestParameters.ids === null || requestParameters.ids === undefined || !requestParameters.ids.length) {
			throw new runtime.RequiredError('ids', 'Required parameter requestParameters.assetId was null or undefined or empty when calling getRulesByids.');
		}
		const { ids, count, search, orderby, expand } = requestParameters;
		const expandQuery = expand && expand.join(',');
		const queryIds = ids.map((id, index) => (index === 0 ? `id eq '${id}'` : ` or id eq '${id}'`)).join('');

		let url = `/api/v1/Documents?$filter={id}`.replace(`{${'id'}}`, encodeURIComponent(String(queryIds)));
		if (search) {
			url = url.concat(`&$search="${search}"`);
		}
		if (count) {
			url = url.concat(`&$count=${count}`);
		}
		if (orderby) {
			url = url.concat(`&$orderby=${orderby}`);
		}
		if (expandQuery) {
			url = url.concat(`&$expand=${expandQuery}`);
		}
		const response = await this.request(
			{
				path: url,
				method: 'GET',
				headers: {
					'X-INFA-ORG-ID': this.tenantId,
				},
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}
	async getRuleInfoByIds(
		requestParameters: Omit<IGetFrsServiceRequest, 'filter' | 'from' | 'size'>,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<IGetFrsServiceResponse> {
		const response = await this.getRuleInfoByIdsRaw(requestParameters, initOverrides);
		return response.value();
	}
	async getRulesInfoRaw(
		requestParameters: Omit<IGetFrsServiceRequest, 'ids'>,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<runtime.ApiResponse<IGetFrsServiceResponse>> {
		if (requestParameters.from === null || requestParameters.from === undefined) {
			throw new runtime.RequiredError('from', 'Required parameter requestParameters.assetId was null or undefined or empty when calling getRulesByids.');
		}
		if (requestParameters.count === null || requestParameters.count === undefined) {
			throw new runtime.RequiredError('count', 'Required parameter requestParameters.count was null or undefined  when calling getRulesByids.');
		}
		if (requestParameters.orderby === null || requestParameters.orderby === undefined) {
			throw new runtime.RequiredError('orderby', 'Required parameter requestParameters.orderby was null or undefined  when calling getRulesByids.');
		}
		if (requestParameters.size === null || requestParameters.size === undefined) {
			throw new runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined or empty when calling getRulesByids.');
		}
		const {
			filter: { documentType, name, description },
			search,
			size,
			from,
			count,
			expand,
			orderby,
		} = requestParameters;

		const typeQuery = documentType?.map((x, index) => (index === 0 ? `documentType eq '${x}'` : ` or documentType eq '${x}'`)).join('');
		const expandQuery = expand && expand.join(',');
		const nameQuery = name && `contains(name,'${name}')`;
		const descriptionQuery = description && `contains(name,'${description}')`;

		const query = [typeQuery, nameQuery, descriptionQuery];

		const params =
			query.filter(Boolean).length === 1
				? query
						.filter(Boolean)
						.map((x) => `(${x})`)
						.join('')
				: query.map((x, index) => (index === 0 ? x && `${x}` : x && ` and ${x}`)).join('');
		let url = `/api/v1/Documents?$filter={id}`.replace(`{${'id'}}`, encodeURIComponent(String(params)));
		if (size) {
			url = url.concat(`&$top=${size}`);
		}
		if (from >= 0) {
			console.log(from);
			url = url.concat(`&$skip=${from}`);
		}
		if (count) {
			url = url.concat(`&$count=${count}`);
		}
		if (orderby) {
			url = url.concat(`&$orderby=${orderby}`);
		}
		if (search) {
			url = url.concat(`&$search="${search}"`);
		}
		if (expand) {
			url = url.concat(`&$expand=${expandQuery}`);
		}

		const response = await this.request(
			{
				path: url,
				method: 'GET',
				headers: {
					'X-INFA-ORG-ID': this.tenantId,
				},
			},
			initOverrides,
		);

		return new runtime.JSONApiResponse(response);
	}
	async getRulesInfo(
		requestParameters: Omit<IGetFrsServiceRequest, 'ids'>,
		initOverrides?: RequestInit | runtime.InitOverrideFunction,
	): Promise<IGetFrsServiceResponse> {
		const response = await this.getRulesInfoRaw(requestParameters, initOverrides);
		return response.value();
	}
	async getRulesFromRO(ids: string[]): Promise<IElasticSearchResp> {
		if (!ids.length) {
			return { hits: [], totalHits: 0 };
		}

		const {
			search: { elasticService },
		} = ServiceRegistry.get();
		const query = {
			from: 0,
			size: 1000,
			query: {
				bool: {
					must: [
						{ terms: { elementType: ['OBJECT'] } },
						{
							terms: {
								[CoreAttr.Identity]: [...ids],
							},
						},
					],
				},
			},
		};
		return elasticService.execute(query);
	}
	async getAllRulesForTable(id: string, args: Omit<IGetFrsServiceRequest, 'filter' | 'ids'>): Promise<IGetFrsServiceResponse> {
		const {
			search: { hybridSearchApi },
		} = ServiceRegistry.get();
		const traversalQuery = `(type ${CoreClz.DataSet} with identity in ('${id}')) containing type ${CoreClz.DataElement} related through all to type ${GovernanceClz.RuleInstance}`;
		const rules = await hybridSearchApi
			.search({
				xINFASEARCHLANGUAGE: SearchXINFASEARCHLANGUAGE.KnowledgeGraphSearch,
				body: {
					size: -1,
					query: traversalQuery,
					select: { elementType: 'object', type: [GovernanceClz.RuleInstance] },
					sort: [{ [CoreAttr.Identity]: { order: 'asc' } }],
				} as any,
				xINFAORGID: this.tenantId,
			})
			.then((resp: any) => resp?.hits?.hits?.map((hit: { attributes: any }) => hit.attributes) || []);
		const roIds = rules.map((x: any) => x[CoreAttr.Identity]);
		const rulesDetails = await this.getRulesFromRO(roIds);
		const techRuleRef: string[] = rulesDetails?.hits?.map((hit) => hit?.[GovernanceAttr.TechnicalRuleReference]);
		return this.getRuleInfoByIds({ ids: techRuleRef, ...args });
	}

	async getAllRulesForDataElement(ids: string[], args: Omit<IGetFrsServiceRequest, 'filter' | 'from' | 'size' | 'ids'>): Promise<IGetFrsServiceResponse> {
		const {
			search: { hybridSearchApi },
		} = ServiceRegistry.get();
		const traversalQuery = [`related through all to type ${GovernanceClz.RuleInstance}`]
			.map((x) => `(type ${CoreClz.DataElement} with identity in ('${ids.join("', '")}')) ${x}`)
			.join(', ');

		const rules = await hybridSearchApi
			.search({
				xINFASEARCHLANGUAGE: SearchXINFASEARCHLANGUAGE.KnowledgeGraphSearch,
				body: {
					size: -1,
					query: traversalQuery,
					select: { elementType: 'object', type: [GovernanceClz.RuleInstance] },

					sort: [{ [CoreAttr.Identity]: { order: 'asc' } }],
				} as any,
				xINFAORGID: this.tenantId,
			})
			.then((resp: any) => resp?.hits?.hits?.map((hit: { attributes: any }) => hit.attributes) || []);
		const roIds = rules.map((x: any) => x[CoreAttr.Identity]);
		const rulesDetails = await this.getRulesFromRO(roIds);
		const techRuleRefs = rulesDetails.hits.map((hit) => hit?.[GovernanceAttr.TechnicalRuleReference]);
		return this.getRuleInfoByIds({ ids: techRuleRefs, ...args });
	}
}

export const initializeFrsService = ({ fetchApi, serviceBaseURLs, tenantId }: Required<IInitializeServiceOptions>) => {
	const frsService = new FrsService(
		new runtime.Configuration({
			fetchApi,
			basePath: serviceBaseURLs['frs'],
		}),
		tenantId,
	);
	return frsService;
};
